import React from "react";
import { Flame, Star } from "lucide-react";

const SHEET_W = 816;
const SHEET_H = 1056;

export default function ReviewQR() {
  return (
    <div
      data-testid="review-qr-standalone"
      className="bg-black relative overflow-hidden flex flex-col items-center"
      style={{ width: SHEET_W, height: SHEET_H }}
    >
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(255,59,48,0.22), transparent 60%)" }} />
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-[#FF3B30]" />

      {/* Header */}
      <div className="relative flex items-center gap-3 mt-16">
        <Flame className="w-8 h-8 text-[#FF3B30]" />
        <span className="font-['Anton'] text-4xl tracking-widest uppercase text-white">
          Smokey <span className="text-[#FF3B30]">AF</span> Barbecue
        </span>
      </div>

      {/* Stars */}
      <div className="relative flex gap-2 mt-10">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-10 h-10 text-[#FF8C00]" fill="#FF8C00" />
        ))}
      </div>

      {/* Headline */}
      <h1 className="relative font-['Anton'] uppercase text-white leading-[0.9] text-center mt-8" style={{ fontSize: 76 }}>
        Enjoyed
        <br />
        the food?
      </h1>
      <p className="relative font-['Anton'] uppercase tracking-tight text-[#FF3B30] mt-3 text-center" style={{ fontSize: 44 }}>
        Leave us a review!
      </p>

      {/* QR */}
      <div className="relative bg-white p-6 mt-10" style={{ boxShadow: "0 0 0 6px #FF3B30" }}>
        <img
          src="/review-qr-code.png"
          alt="Scan to leave a review"
          style={{ width: 380, height: 380 }}
        />
      </div>

      {/* Footer */}
      <p className="relative font-['Outfit'] uppercase tracking-[0.35em] text-zinc-300 mt-9 text-lg">
        Scan with your phone camera
      </p>
      <p className="relative font-['Outfit'] uppercase tracking-[0.25em] text-zinc-500 mt-2 text-sm">
        Find us on Facebook · Smokey AF Barbecue
      </p>
    </div>
  );
}
